import Vue from 'vue'
import {
  RECEIVING_CODES,
  RECEIVE_CODE_FAILURE,
  RECEIVE_ACCOUNTS_FAILURE,
  RECEIVE_SERIES_FAILURE,
  RECEIVE_LOCATIONS_FAILURE,
  RECEIVE_SETS_FAILURE,
  RECEIVE_TAX_CODES_FAILURE,
  RECEIVE_FREE_FIELDS_FAILURE,
  RECEIVE_COMPANIES_FAILURE,
  RECEIVE_PRODUCTIONS_FAILURE,
  RECEIVE_PERIODS_FAILURE,
  RECEIVE_SOURCECODES_FAILURE,
  RECEIVE_EMPLOYEE_FAILURE,
  RECEIVE_INVOICES_FAILURE,
  RECEIVE_CURRENCIES_FAILURE,
  RECEIVE_ALL_INVOICES,
  RECEIVE_ALL_EMPLOYEE,
  RECEIVE_ALL_ACCOUNTS,
  RECEIVE_ALL_SERIES,
  RECEIVE_ALL_LOCATIONS,
  RECEIVE_ALL_SETS,
  RECEIVE_ALL_TAX_CODES,
  RECEIVE_ALL_FREE_FIELDS,
  RECEIVE_ALL_COMPANIES,
  RECEIVE_ALL_PRODUCTIONS,
  RECEIVE_ALL_PERIODS,
  RECEIVE_ALL_SOURCECODES,
  RECEIVE_ALL_CURRENCIES
} from '../mutationTypes'
import { checkStatus, getHeaders, parseJSON, buildUrl } from '../../utils/api'
import handleXHRError from '../../utils/helpers/HandleXHRError'

// initial State
const state = {
  data: {
  },
  receivingData: false,
  receiveDataFailure: false
}

// actions (commits are the equivalent of actions in Redux)
const actions = {
  fetchAllAccounts (store) {
    const instanceUrl = this.getters.getActiveInstance.url
    const headers = getHeaders(this.getters.getToken)
    this.commit(RECEIVING_CODES, true)

    return Vue.http({ url: buildUrl('accounts?meta_choices=True', null, instanceUrl), headers, method: 'options' })
      .then(checkStatus)
      .then(parseJSON)
      .then(response => {
        this.commit(RECEIVING_CODES, false)
        if (!response.hasOwnProperty('choices')) return this.commit(RECEIVE_ACCOUNTS_FAILURE, 'Error fetching accounts')
        if (!response || !Array.isArray(response.choices)) return this.commit(RECEIVE_ACCOUNTS_FAILURE, 'Error normalizing response')
        this.commit(RECEIVE_ALL_ACCOUNTS, { data: response.choices })
        return response.choices
      })
      .catch(e => {
        this.commit(RECEIVING_CODES, false)
        this.commit(RECEIVE_ACCOUNTS_FAILURE, handleXHRError(e))
      })
  },
  fetchAllSeries (store) {
    const instanceUrl = this.getters.getActiveInstance.url
    const headers = getHeaders(this.getters.getToken)
    this.commit(RECEIVING_CODES, true)

    return Vue.http({ url: buildUrl('series?meta_choices=True', null, instanceUrl), headers, method: 'options' })
      .then(checkStatus)
      .then(parseJSON)
      .then(response => {
        this.commit(RECEIVING_CODES, false)
        if (!response.hasOwnProperty('choices')) return this.commit(RECEIVE_SERIES_FAILURE, 'Error fetching series')
        if (!response || !Array.isArray(response.choices)) return this.commit(RECEIVE_SERIES_FAILURE, 'Error normalizing response')
        this.commit(RECEIVE_ALL_SERIES, { data: response.choices })
        return response.choices
      })
      .catch(e => {
        this.commit(RECEIVING_CODES, false)
        this.commit(RECEIVE_SERIES_FAILURE, handleXHRError(e))
      })
  },
  fetchAllLocations (store) {
    const instanceUrl = this.getters.getActiveInstance.url
    const headers = getHeaders(this.getters.getToken)
    this.commit(RECEIVING_CODES, true)

    return Vue.http({ url: buildUrl('locations?meta_choices=True', null, instanceUrl), headers, method: 'options' })
      .then(checkStatus)
      .then(parseJSON)
      .then(response => {
        this.commit(RECEIVING_CODES, false)
        if (!response.hasOwnProperty('choices')) return this.commit(RECEIVE_LOCATIONS_FAILURE, 'Error fetching locations')
        if (!response || !Array.isArray(response.choices)) return this.commit(RECEIVE_LOCATIONS_FAILURE, 'Error normalizing response')
        this.commit(RECEIVE_ALL_LOCATIONS, { data: response.choices })
        return response.choices
      })
      .catch(e => {
        this.commit(RECEIVING_CODES, false)
        this.commit(RECEIVE_LOCATIONS_FAILURE, handleXHRError(e))
      })
  },
  fetchAllSets (store) {
    const instanceUrl = this.getters.getActiveInstance.url
    const headers = getHeaders(this.getters.getToken)
    this.commit(RECEIVING_CODES, true)

    return Vue.http({ url: buildUrl('sets?meta_choices=True', null, instanceUrl), headers, method: 'options' })
      .then(checkStatus)
      .then(parseJSON)
      .then(response => {
        this.commit(RECEIVING_CODES, false)
        if (!response.hasOwnProperty('choices')) return this.commit(RECEIVE_SETS_FAILURE, 'Error fetching sets')
        if (!response || !Array.isArray(response.choices)) return this.commit(RECEIVE_SETS_FAILURE, 'Error normalizing response')
        this.commit(RECEIVE_ALL_SETS, { data: response.choices })
        return response.choices
      })
      .catch(e => {
        this.commit(RECEIVING_CODES, false)
        this.commit(RECEIVE_SETS_FAILURE, handleXHRError(e))
      })
  },
  fetchAllTaxCodes (store) {
    const instanceUrl = this.getters.getActiveInstance.url
    const headers = getHeaders(this.getters.getToken)
    this.commit(RECEIVING_CODES, true)

    return Vue.http({ url: buildUrl('countrytaxcodes?meta_choices=True', null, instanceUrl), headers, method: 'options' })
      .then(checkStatus)
      .then(parseJSON)
      .then(response => {
        this.commit(RECEIVING_CODES, false)
        if (!response.hasOwnProperty('choices')) return this.commit(RECEIVE_TAX_CODES_FAILURE, 'Error fetching tax codes')
        if (!response || !Array.isArray(response.choices)) return this.commit(RECEIVE_TAX_CODES_FAILURE, 'Error normalizing response')
        this.commit(RECEIVE_ALL_TAX_CODES, { data: response.choices })
        return response.choices
      })
      .catch(e => {
        this.commit(RECEIVING_CODES, false)
        this.commit(RECEIVE_TAX_CODES_FAILURE, handleXHRError(e))
      })
  },
  fetchAllFreeFields (store) {
    const instanceUrl = this.getters.getActiveInstance.url
    const headers = getHeaders(this.getters.getToken)
    this.commit(RECEIVING_CODES, true)

    return Vue.http({ url: buildUrl('freefields?meta_choices=True', null, instanceUrl), headers, method: 'options' })
      .then(checkStatus)
      .then(parseJSON)
      .then(response => {
        this.commit(RECEIVING_CODES, false)
        if (!response.hasOwnProperty('choices')) return this.commit(RECEIVE_FREE_FIELDS_FAILURE, 'Error fetching free fields')
        if (!response || !Array.isArray(response.choices)) return this.commit(RECEIVE_FREE_FIELDS_FAILURE, 'Error normalizing response')
        this.commit(RECEIVE_ALL_FREE_FIELDS, { data: response.choices })
        return response.choices
      })
      .catch(e => {
        this.commit(RECEIVING_CODES, false)
        this.commit(RECEIVE_FREE_FIELDS_FAILURE, handleXHRError(e))
      })
  },
  fetchAllCompanies (store) {
    const instanceUrl = this.getters.getActiveInstance.url
    const headers = getHeaders(this.getters.getToken)
    this.commit(RECEIVING_CODES, true)

    return Vue.http({ url: buildUrl('companies?meta_choices=True', null, instanceUrl), headers, method: 'options' })
      .then(checkStatus)
      .then(parseJSON)
      .then(response => {
        this.commit(RECEIVING_CODES, false)
        if (!response.hasOwnProperty('choices')) return this.commit(RECEIVE_COMPANIES_FAILURE, 'Error fetching companies')
        if (!response || !Array.isArray(response.choices)) return this.commit(RECEIVE_COMPANIES_FAILURE, 'Error normalizing response')
        this.commit(RECEIVE_ALL_COMPANIES, { data: response.choices })
        return response.choices
      })
      .catch(e => {
        this.commit(RECEIVING_CODES, false)
        this.commit(RECEIVE_COMPANIES_FAILURE, handleXHRError(e))
      })
  },
  fetchAllProductions (store) {
    const instanceUrl = this.getters.getActiveInstance.url
    const headers = getHeaders(this.getters.getToken)
    this.commit(RECEIVING_CODES, true)

    return Vue.http({ url: buildUrl('productions?meta_choices=True', null, instanceUrl), headers, method: 'options' })
      .then(checkStatus)
      .then(parseJSON)
      .then(response => {
        this.commit(RECEIVING_CODES, false)
        if (!response.hasOwnProperty('choices')) return this.commit(RECEIVE_PRODUCTIONS_FAILURE, 'Error fetching productions')
        if (!response || !Array.isArray(response.choices)) return this.commit(RECEIVE_PRODUCTIONS_FAILURE, 'Error normalizing response')
        this.commit(RECEIVE_ALL_PRODUCTIONS, { data: response.choices })
        return response.choices
      })
      .catch(e => {
        this.commit(RECEIVING_CODES, false)
        this.commit(RECEIVE_PRODUCTIONS_FAILURE, handleXHRError(e))
      })
  },
  fetchAllPeriods (store) {
    const instanceUrl = this.getters.getActiveInstance.url
    const headers = getHeaders(this.getters.getToken)
    this.commit(RECEIVING_CODES, true)

    return Vue.http({ url: buildUrl('periods?meta_choices=True', null, instanceUrl), headers, method: 'options' })
      .then(checkStatus)
      .then(parseJSON)
      .then(response => {
        this.commit(RECEIVING_CODES, false)
        if (!response.hasOwnProperty('choices')) return this.commit(RECEIVE_PERIODS_FAILURE, 'Error fetching periods')
        if (!response || !Array.isArray(response.choices)) return this.commit(RECEIVE_PERIODS_FAILURE, 'Error normalizing response')
        this.commit(RECEIVE_ALL_PERIODS, { data: response.choices })
        return response.choices
      })
      .catch(e => {
        this.commit(RECEIVING_CODES, false)
        this.commit(RECEIVE_PERIODS_FAILURE, handleXHRError(e))
      })
  },
  fetchAllSourcecodes (store) {
    const instanceUrl = this.getters.getActiveInstance.url
    const headers = getHeaders(this.getters.getToken)
    this.commit(RECEIVING_CODES, true)

    return Vue.http({ url: buildUrl('sourcecodes?meta_choices=True', null, instanceUrl), headers, method: 'options' })
      .then(checkStatus)
      .then(parseJSON)
      .then(response => {
        this.commit(RECEIVING_CODES, false)
        if (!response.hasOwnProperty('choices')) return this.commit(RECEIVE_SOURCECODES_FAILURE, 'Error fetching periods')
        if (!response || !Array.isArray(response.choices)) return this.commit(RECEIVE_SOURCECODES_FAILURE, 'Error normalizing response')
        this.commit(RECEIVE_ALL_SOURCECODES, { data: response.choices })
        return response.choices
      })
      .catch(e => {
        this.commit(RECEIVING_CODES, false)
        this.commit(RECEIVE_SOURCECODES_FAILURE, handleXHRError(e))
      })
  },
  fetchAllInvoices (store) {
    const instanceUrl = this.getters.getActiveInstance.url
    const headers = getHeaders(this.getters.getToken)
    this.commit(RECEIVING_CODES, true)

    return Vue.http({ url: buildUrl('propay/employeeearnings/', null, instanceUrl), headers, method: 'get' })
      .then(checkStatus)
      .then(parseJSON)
      .then(response => {
        this.commit(RECEIVING_CODES, false)
        if (!response.hasOwnProperty('data')) return this.commit(RECEIVE_INVOICES_FAILURE, 'Error fetching invoices')
        if (!response || !Array.isArray(response.data)) return this.commit(RECEIVE_INVOICES_FAILURE, 'Error normalizing response')
        this.commit(RECEIVE_ALL_INVOICES, { data: response.data })
        return response.data
      })
      .catch(e => {
        this.commit(RECEIVING_CODES, false)
        this.commit(RECEIVE_INVOICES_FAILURE, handleXHRError(e))
      })
  },
  fetchAllEmployees (store) {
    const instanceUrl = this.getters.getActiveInstance.url
    const headers = getHeaders(this.getters.getToken)
    this.commit(RECEIVING_CODES, true)

    return Vue.http({ url: buildUrl('propay/employee/', null, instanceUrl), headers, method: 'get' })
      .then(checkStatus)
      .then(parseJSON)
      .then(response => {
        this.commit(RECEIVING_CODES, false)
        if (!response.hasOwnProperty('data')) return this.commit(RECEIVE_EMPLOYEE_FAILURE, 'Error fetching accounts')
        if (!response || !Array.isArray(response.data)) return this.commit(RECEIVE_EMPLOYEE_FAILURE, 'Error normalizing response')
        this.commit(RECEIVE_ALL_EMPLOYEE, { data: response.data })
        return response.data
      })
      .catch(e => {
        this.commit(RECEIVING_CODES, false)
        this.commit(RECEIVE_EMPLOYEE_FAILURE, handleXHRError(e))
      })
  },
  fetchAllCurrencies (store) {
    const instanceUrl = this.getters.getActiveInstance.url
    const headers = getHeaders(this.getters.getToken)
    this.commit(RECEIVING_CODES, true)

    return Vue.http({ url: buildUrl('currencies?meta_choices=True', null, instanceUrl), headers, method: 'options' })
      .then(checkStatus)
      .then(parseJSON)
      .then(response => {
        this.commit(RECEIVING_CODES, false)
        if (!response.hasOwnProperty('choices')) return this.commit(RECEIVE_CURRENCIES_FAILURE, 'Error fetching currencies')
        if (!response || !Array.isArray(response.choices)) return this.commit(RECEIVE_CURRENCIES_FAILURE, 'Error normalizing response')
        this.commit(RECEIVE_ALL_CURRENCIES, { data: response.choices })
        return response.choices
      })
      .catch(e => {
        this.commit(RECEIVING_CODES, false)
        this.commit(RECEIVE_CURRENCIES_FAILURE, handleXHRError(e))
      })
  }
}

// getters (like selectors in Redux)
const getters = {
  getAllCodes: (state, rootState) => {
    return state.data
    // return state.data.codes.accounts ? Object.values(state.data.codes.accounts).map(v => Object.assign({}, v)) : []
  },
  getReceivingStatus: (state) => {
    return state.receivingData
  }
}

// mutations (equivalent of reducers in Redux. These funcs must be synchronous)
const mutations = {
  [RECEIVE_ALL_ACCOUNTS] (state, results) {
    const { data } = results
    state.data.accounts = data
    return true
  },
  [RECEIVE_ALL_SERIES] (state, results) {
    const { data } = results
    state.data.series = data
    return true
  },
  [RECEIVE_ALL_LOCATIONS] (state, results) {
    const { data } = results
    state.data.locations = data
    return true
  },
  [RECEIVE_ALL_SETS] (state, results) {
    const { data } = results
    state.data.sets = data
    return true
  },
  [RECEIVE_ALL_TAX_CODES] (state, results) {
    const { data } = results
    state.data.taxcodes = data
    return true
  },
  [RECEIVE_ALL_FREE_FIELDS] (state, results) {
    const { data } = results
    state.data.freefield1 = data
    state.data.freefield2 = data
    return true
  },
  [RECEIVE_ALL_COMPANIES] (state, results) {
    const { data } = results
    state.data.companies = data
    return true
  },
  [RECEIVE_ALL_PRODUCTIONS] (state, results) {
    const { data } = results
    state.data.productions = data
    return true
  },
  [RECEIVE_ALL_PERIODS] (state, results) {
    const { data } = results
    state.data.periods = data
    return true
  },
  [RECEIVE_ALL_SOURCECODES] (state, results) {
    const { data } = results
    state.data.sourcecodes = data
    return true
  },
  [RECEIVE_ALL_EMPLOYEE] (state, results) {
    const { data } = results
    state.data.employeecodes = data
    return true
  },
  [RECEIVE_ALL_INVOICES] (state, results) {
    const { data } = results
    state.data.invoiceCodes = data
    return true
  },
  [RECEIVE_ALL_CURRENCIES] (state, results) {
    const { data } = results
    state.data.currencies = data
    return true
  },
  [RECEIVE_EMPLOYEE_FAILURE] (state, error) {
    state.receiveDataFailure = error
  },
  [RECEIVE_INVOICES_FAILURE] (state, error) {
    state.receiveDataFailure = error
  },
  [RECEIVING_CODES] (state, payload) {
    state.receivingData = payload
  },
  [RECEIVE_CODE_FAILURE] (state, error) {
    state.receiveDataFailure = error
  },
  [RECEIVE_ACCOUNTS_FAILURE] (state, error) {
    state.receiveDataFailure = error
  },
  [RECEIVE_SERIES_FAILURE] (state, error) {
    state.receiveDataFailure = error
  },
  [RECEIVE_LOCATIONS_FAILURE] (state, error) {
    state.receiveDataFailure = error
  },
  [RECEIVE_SETS_FAILURE] (state, error) {
    state.receiveDataFailure = error
  },
  [RECEIVE_TAX_CODES_FAILURE] (state, error) {
    state.receiveDataFailure = error
  },
  [RECEIVE_FREE_FIELDS_FAILURE] (state, error) {
    state.receiveDataFailure = error
  },
  [RECEIVE_COMPANIES_FAILURE] (state, error) {
    state.receiveDataFailure = error
  },
  [RECEIVE_PRODUCTIONS_FAILURE] (state, error) {
    state.receiveDataFailure = error
  },
  [RECEIVE_PERIODS_FAILURE] (state, error) {
    state.receiveDataFailure = error
  },
  [RECEIVE_SOURCECODES_FAILURE] (state, error) {
    state.receiveDataFailure = error
  },
  [RECEIVE_EMPLOYEE_FAILURE] (state, error) {
    state.receiveDataFailure = error
  },
  [RECEIVE_CURRENCIES_FAILURE] (state, error) {
    state.receiveDataFailure = error
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/showCode.js